
<component
  :is="as"
  class="icon-link"
  :class="{ reverse }"
  v-bind="$attrs"
  v-on="$listeners"
>
  <span>
    <slot />
  </span>

  <icon :name="icon" />
</component>
